import { TApiServiceOptions } from "../apiService";
import { API } from "../../core/apiurl";
import {
  TClearSingleNotificationResponse,
  TNotificationsResponse,
  TReadUserNotificationResponse,
} from "./notifications.types";
import { authenticatedApiService } from "../apiservice.auth";

class NotificationsService {
  getUserNotifications(pageNo: number, options?: TApiServiceOptions) {
    const query = `?page=${pageNo}`;
    return authenticatedApiService.get<TNotificationsResponse>(
      API.notifications + query,
      options,
    );
  }

  clearUserNotifications(read: string, options?: TApiServiceOptions) {
    const query = `?read_all=${read}`;
    return authenticatedApiService.get<TNotificationsResponse>(
      API.notifications + query,
      options,
    );
  }

  readUserNotification(id: string, options?: TApiServiceOptions) {
    return authenticatedApiService.post<TReadUserNotificationResponse>(
      `${API.notifications}${id}/${API.markNotificationRead}`,
      {},
      options,
    );
  }

  clearSingleNotification(id: string, options?: TApiServiceOptions) {
    return authenticatedApiService.post<TClearSingleNotificationResponse>(
      `${API.notifications}${id}/${API.clearNotificationRead}`,
      {},
      options,
    );
  }
}

export const notificationsService = new NotificationsService();
